// extracted by mini-css-extract-plugin
export var ErrorIcon = "index-module--ErrorIcon--f386f";
export var ErrorMessage = "index-module--ErrorMessage--f938d";
export var WarningMessage = "index-module--WarningMessage--692b0";